module.exports = __webpack_public_path__ + "static/media/3.db9bb4d9.JPG";